import React from 'react';
import { MenuItem, MenuItemProps } from '../menu/menu-item.view';

export type SelectItemProps = MenuItemProps & {
  value: string;
};

export const SelectItem: React.FC<SelectItemProps> = React.forwardRef<HTMLElement, SelectItemProps>((props, ref) => <MenuItem {...props} ref={ref} />);
